import { createRoot } from "react-dom/client";
import { App } from "./App";

/*
  Strategy to reduce deployment
  css: domain class, actual styles in Elementor Custom Code
  js: custom functions in Elementor Custom Code
*/

document.addEventListener('DOMContentLoaded', function() {
  const res = document.querySelectorAll(".rocksolid-custom-search");
  for (const container of res) {
    const props = Array.from(container.attributes).reduce((a, attribute) => {
      a[attribute.name] = attribute.value;
      return a;
    }, {});
    const root = createRoot(container);
    root.render(<App {...props} />);
  }
});
